import { render, staticRenderFns } from "./AppointBadgeDialog.vue?vue&type=template&id=dfe0b82c"
import script from "./AppointBadgeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AppointBadgeDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports